import { getColumns, uniqueName } from './ReportHomePage.Grid';
import { Unsubscribe } from 'redux';
import actions from '../../../store/actions';
import appRoutes from '../../../infrastructure/constants/appRoutes';
import CopyReportConfigModal from '../../Common/Modals/CopyReportConfigModal/CopyReportConfigModal';
import CopyReportConfigModalState from '../../Common/Modals/CopyReportConfigModal/CopyReportConfigModalState';
import GridRefresh from '../../../store/state/events/GridRefresh';
import history from '../../../infrastructure/helpers/react/history';
import identityStorage from '../../../infrastructure/authorization/identityStorage';
import ReportConfigGridItem from '../../../types/report/ReportConfigGridItem';
import ServerDataGrid from '../../Common/DataGrid/ServerDataGrid/ServerDataGrid';
import store from '../../../store/store';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';
import writeUserRoles from '../../../infrastructure/constants/identity/writeUserRoles';
import ImportReportConfigModal from '../../Common/Modals/ImportReportConfigModal/ImportReportConfigModal';
import DownloadModal from '../../Common/Modals/DownloadModal/DownloadModal';
import DownloadReportConfigSummaryModal from '../../Common/Modals/DownloadReportConfigSummaryModal/DownloadReportConfigSummaryModal';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import WarningModal from '../../Common/Modals/WarningModal/WarningModal';
import { AxiosResponse } from 'axios';
import reportConfigBundleSerializer from '../../../infrastructure/helpers/report/import/reportConfigBundleSerializer';
import dataSourceKind from '../../../infrastructure/constants/dataSourceKind';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import ReportConfig from '../../../types/report/ReportConfig';
import { getConfigDataSources } from '../Import/ServerCalls';
import { getReportDataSources, getReportFields } from './ReportPage/ReportPage.Helpers';
import './ReportHomePage.scss';
import validateConfigName from '../../../infrastructure/helpers/common/validator/nameValidator';
import ReportConfigInfoModal from '../../Common/Modals/ReportConfigInfoModal/ReportConfigInfoModal';
import messageHelper from '../../Common/Message/MessageHelper';
import copyObject from '../../../infrastructure/helpers/common/copyObject';
import CustomIcon from '../../Common/BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../../Common/BootstrapIcons/Tooltip/IconTooltip';
import { ReactComponent as DownloadIcon } from '../../Common/BootstrapIcons/download.svg';
import { ReactComponent as SearchIcon } from '../../Common/BootstrapIcons/search.svg';
import { ReactComponent as ClearIcon } from '../../Common/BootstrapIcons/close.svg';
import Spinner from '../../Common/Spinner/Spinner';
import SwitchComponent from '../../Common/Switch/Switch';
import userRole from '../../../infrastructure/constants/identity/userRole';
import ReportSettings from '../../../types/report/ReportSettings';
import GlobalModuleConfig from '../../../types/report/GlobalModuleConfig';
import clientWriteUserRoles from '../../../infrastructure/constants/identity/clientWriteUserRole';
import ContextMenuOptionType from '../../../types/report/ContextMenuOptionType';
import SelectOption from '../../../infrastructure/types/SelectOption';
import React from 'react';
import ChangeDataSourceModal from '../../Common/Modals/ChangeConfigDataSourceModal/ChangeDataSourceModal';

interface State {
    enabled: boolean;
    name: string;
    showDownloadPopup: boolean;
    reportConfigId: number;
    showWarningModal: boolean;
    message: string;
    removeConfig: ReportConfigGridItem;
    showSpinnerForId: number;
    showSpinnerForDownloadId: number;
    showConfigInfoPopup: boolean;
    configInfo: ReportConfigGridItem;
    currentConfigInfo: ReportConfigGridItem;
    showDownloadSummarySpinner: boolean;
    showDownloadSummaryModal: boolean;
    isFourEyesReleaseEnabled: boolean;
    showPopupOnDisableFourEyesRelease: boolean;
    showFourEyesReleaseSwitch: boolean;
    selectedConfigId: number;
    changeDataSourceConfig: ReportConfigGridItem,
    showPopupChangeDataSource: boolean;
    showSpinnerForChangeDataSourceId: number;
    showSpinnerForArchiveId: number;
    showSpinnerForRemoveConfigId: number;
}

const disableFourEyesReleaseMessage = 'Turning off "Four eyes release process"\r\n would automatically approve release requests.\r\n Are you sure you would like to proceed ?';

class ReportHomePage extends React.Component<any, State> {
    private unsubscribe: Unsubscribe | undefined;

    constructor(props: any) {
        super(props);

        this.state = {
            showSpinnerForId: 0,
            showSpinnerForDownloadId: 0,
            enabled: true,
            name: '',
            showDownloadPopup: false,
            reportConfigId: 0,
            showWarningModal: false,
            message: '',
            removeConfig: {} as ReportConfigGridItem,
            showConfigInfoPopup: false,
            configInfo: {} as ReportConfigGridItem,
            currentConfigInfo: {} as ReportConfigGridItem,
            showDownloadSummarySpinner: false,
            showDownloadSummaryModal: false,
            isFourEyesReleaseEnabled: true,
            showPopupOnDisableFourEyesRelease: false,
            showFourEyesReleaseSwitch: false,
            selectedConfigId: 0,
            changeDataSourceConfig: {} as ReportConfigGridItem,
            showPopupChangeDataSource: false,
            showSpinnerForChangeDataSourceId: 0,
            showSpinnerForArchiveId: 0,
            showSpinnerForRemoveConfigId: 0
        };

        this.refreshGridListener = this.refreshGridListener.bind(this);
        this.onEnabledChange = this.onEnabledChange.bind(this);
        this.onNameChange = this.onNameChange.bind(this);
        this.onClearClick = this.onClearClick.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onDownloadClick = this.onDownloadClick.bind(this);
        this.onDownloadTypeSelected = this.onDownloadTypeSelected.bind(this);
        this.onRemoveClick = this.onRemoveClick.bind(this);
        this.onRemoveConfirmed = this.onRemoveConfirmed.bind(this);
        this.onCopyConfigSourceClick = this.onCopyConfigSourceClick.bind(this);
        this.onInfoClick = this.onInfoClick.bind(this);
        this.onMouseLeaveDerscription = this.onMouseLeaveDerscription.bind(this);
        this.onOpenDownloadSummaryModal = this.onOpenDownloadSummaryModal.bind(this);
        this.onDownloadSummaryConfirmed = this.onDownloadSummaryConfirmed.bind(this);
        this.onEnableDisableForEyesReleaseSwitch = this.onEnableDisableForEyesReleaseSwitch.bind(this);
        this.onRecordsFetched = this.onRecordsFetched.bind(this);
        this.switchFourEyesRelease = this.switchFourEyesRelease.bind(this);
        this.getContextMenuOptions = this.getContextMenuOptions.bind(this);
        this.onChangeDataSourceClick = this.onChangeDataSourceClick.bind(this);
        this.onChangeDataSourceAccepted = this.onChangeDataSourceAccepted.bind(this);
        this.onArchiveClick = this.onArchiveClick.bind(this);
    }

    onChangeDataSourceClick(reportConfig: ReportConfigGridItem) {

        this.setState({ changeDataSourceConfig: reportConfig, showPopupChangeDataSource: true });
    }

    async onChangeDataSourceAccepted(from: number, to: number) {

        this.setState({ showSpinnerForChangeDataSourceId: this.state.changeDataSourceConfig.id });
        try {
            await httpClient.postSimple('report/change-datasource', { fromDataSourceId: from, toDataSourceId: to, reportConfigId: this.state.changeDataSourceConfig.id, mapping: null });
            this.setState({ showSpinnerForChangeDataSourceId: 0, showPopupChangeDataSource: false });
        }
        catch (error) {
            let err = error as any;

            messageHelper.showMesage(err.response.data.message);

            this.setState({ showSpinnerForChangeDataSourceId: 0, showPopupChangeDataSource: false });
        }
    }

    componentDidMount(): void {

        this.unsubscribe = store.subscribe(this.refreshGridListener);

        let name = localStorage.getItem('reportConfigSearchText') || '';

        this.setState({ name });
    }

    componentWillUnmount(): void {
        (this.unsubscribe as Unsubscribe)();
    }

    refreshGridListener(): void {

        let state = store.getState();

        let proceed =
            state.action === actions.copyReportConfigModal.saveSuccess ||
            state.action === actions.importReportConfigModal.saveSuccess;

        if (!proceed) {
            return;
        }

        this.refreshGrid();
    }

    onCreateNewClick() {
        history.push(appRoutes.reporting.dataSources);
    }

    onImportClick() {

        store.dispatch({ type: actions.importReportConfigModal.open, payload: null as any });
    }

    onEnabledChange(e: React.ChangeEvent<HTMLInputElement>): void {

        this.setState({ enabled: !e.target.checked }, this.refreshGrid);
    }

    onNameChange(e: React.ChangeEvent<HTMLInputElement>): void {

        this.setState({ name: e.target.value });

        localStorage.setItem('reportConfigSearchText', e.target.value);
    }

    onClearClick(): void {
        this.setState({ name: '' }, () => {
            localStorage.setItem('reportConfigSearchText', '');
            this.refreshGrid();
        });
    }

    onSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        this.refreshGrid();
    }

    onEditClick(id: number): void {

        let route = urlHelper.buildUrl(appRoutes.reporting.edit, { id: id });

        history.push(route);
    }

    onCopyClick(config: ReportConfigGridItem) {

        let state = {} as CopyReportConfigModalState;

        state.id = config.id;
        state.name = `${config.name} - Copy`;
        state.regimeOriginal = config.regime;
        state.regimeOverride = config.regime;
        state.selectedRegime = config.regime;
        state.selectedSubRegime = config.subRegime || '';
        state.validate = validateConfigName;
        state.isOpen = true;
        state.copyFieldEnrichmentLogic = true;
        state.regimeOverrideSelected = false;
        store.dispatch({ type: actions.copyReportConfigModal.open, payload: state });
    }

    refreshGrid(): void {

        let payload: GridRefresh = {
            uniqueName: uniqueName,
            useCurrentPage: false
        };

        store.dispatch({ type: actions.grid.refresh, payload: payload });
    }

    onDownloadClick(id: number): Promise<void> {

        this.setState({ showDownloadPopup: true, reportConfigId: id, showSpinnerForDownloadId: id });
        return Promise.resolve();
    }

    async onDownloadTypeSelected(downloadAsFragmented: boolean, useReleasedConfig: boolean): Promise<void> {

        this.setState({ showDownloadPopup: false });
        let route = urlHelper.buildRoute(['report', this.state.reportConfigId, downloadAsFragmented ? 'export-fragmented' : 'export-full', useReleasedConfig]);

        await httpClient.download(route);

        this.setState({ showSpinnerForDownloadId: 0 });
    }

    onRemoveClick(config: ReportConfigGridItem) {

        let message = `Are you sure you want to delete config ${config.name}?`;

        this.setState({ message, showWarningModal: true, removeConfig: config });
    }

    async onRemoveConfirmed() {

        this.setState({ showWarningModal: false, showSpinnerForRemoveConfigId: this.state.removeConfig.id });

        let route = urlHelper.buildRoute(['report', this.state.removeConfig.id]);

        await httpClient.delete(route).then(this.onSuccess);

        this.setState({ showSpinnerForRemoveConfigId: 0 });
    }


    onSuccess(response: AxiosResponse): void {

        let payload: GridRefresh = {
            uniqueName: uniqueName,
            useCurrentPage: true
        };

        store.dispatch({ type: actions.grid.refresh, payload: payload });
    };

    async onCopyConfigSourceClick(id: number): Promise<void> {

        this.setState({ showSpinnerForId: id });

        let url = 'report/' + id;

        var response = await httpClient.get<ReportConfig>(url);

        let res = await getReportDataSources(response.data);

        let dataSources = await getConfigDataSources(res.data.filter(x => x.dataSourceKind !== dataSourceKind.globalRef).map(x => x.id as number),
            res.data.filter(x => x.dataSourceKind === dataSourceKind.globalRef).map(x => x.id as number)
        );

        let reportFields = (await getReportFields(response.data)).data;

        let globalModule = {} as GlobalModuleConfig;

        let globalModuleDataSources = [] as IngestionConfig[];

        if (response.data.globalModuleConfigId) {

            let url = 'report/' + response.data.globalModuleConfigId;

            let res = await httpClient.get<GlobalModuleConfig>(url);

            globalModule = res.data;

            let dataSourcesIds = globalModule.refDataSources.map(x => x.id);

            url = urlHelper.buildCollectionParamUrl('ingestion', 'ids', dataSourcesIds);

            let dsResponse = await httpClient.get<IngestionConfig[]>(url);

            globalModuleDataSources = dsResponse.data;
        }

        let json = reportConfigBundleSerializer.serialize(response.data, dataSources, reportFields, globalModule, globalModuleDataSources);

        await navigator.clipboard.writeText(json);

        this.setState({ showSpinnerForId: 0 });
    }

    async onGetDataSourceSuccess(dataSources: IngestionConfig[]): Promise<void> {

        let json = reportConfigBundleSerializer.serialize(this.props.config, dataSources, this.props.collections.reportFields);

        await navigator.clipboard.writeText(json);
    }

    onInfoClick(configInfo: ReportConfigGridItem): void {
        this.setState({ configInfo, showConfigInfoPopup: true })
    }

    async onMouseLeaveDerscription(gridInfo: ReportConfigGridItem, description: string) {

        if (this.state.currentConfigInfo.id !== gridInfo.id && description && gridInfo.description?.trim() !== description?.trim()) {

            gridInfo.description = description;

            let url = urlHelper.buildRoute(['report', 'update', 'description']);

            await httpClient.put(url, gridInfo);

            messageHelper.showMesage(`Description "${description}" for config with Id: ${gridInfo.id} was saved.`, false, true);

            let config = copyObject(gridInfo);

            config.description = description;

            this.setState({ currentConfigInfo: config });
        }
    }

    onOpenDownloadSummaryModal(): void {
        this.setState({ showDownloadSummaryModal: true });
    }

    async onDownloadSummaryConfirmed(includeArchived: boolean): Promise<void> {
        this.setState({ showDownloadSummaryModal: false, showDownloadSummarySpinner: true });

        try {
            let route = urlHelper.buildUrl('report/download/config/summary/all', { includeArchived });

            await httpClient.download(route);
        }
        finally {
            this.setState({ showDownloadSummarySpinner: false });
        }
    }

    onViewReleasedClick(id: number): void {

        let route = urlHelper.buildUrl(appRoutes.reporting.edit, { id: id, released: true });

        history.push(route);
    }

    async onRecordsFetched(): Promise<void> {

        let identity = identityStorage.get();

        if (identity.userRole === userRole.localAdmin) {
            let response = await httpClient.getWithAsyncAwait('report/for-eyes-release');

            this.setState({ isFourEyesReleaseEnabled: response.data, showFourEyesReleaseSwitch: true });
        }
    }

    async onEnableDisableForEyesReleaseSwitch(isEnabled: boolean) {

        if (!isEnabled) {
            this.setState({ showPopupOnDisableFourEyesRelease: true });
        }
        else {
            this.switchFourEyesRelease(isEnabled);

            this.setState({ isFourEyesReleaseEnabled: isEnabled });
        }

    }

    async switchFourEyesRelease(isEnabled: boolean) {
        await httpClient.post('report/for-eyes-release', { isFourEyesReleaseEnabled: isEnabled } as ReportSettings);

        this.setState({ isFourEyesReleaseEnabled: isEnabled, showPopupOnDisableFourEyesRelease: false });
    }

    getContextMenuOptions() {
        return [{ text: 'Open config in new tab', value: ContextMenuOptionType.OpenInNewTab } as SelectOption];
    }

    async onArchiveClick(config: ReportConfigGridItem, action: string): Promise<any> {

        let route = urlHelper.buildRoute(['report', config.id, action]);

        try {
            this.setState({ showSpinnerForArchiveId: config.id});

            await httpClient.postSimple(route);

            let payload: GridRefresh = {
                uniqueName: uniqueName,
                useCurrentPage: true
            };

            store.dispatch({ type: actions.grid.refresh, payload: payload });

            this.setState({ showSpinnerForArchiveId: 0 });
        }
        catch (error) {
            let err = error as any;

            messageHelper.showMesage(err.response.data.message);

            this.setState({ showSpinnerForArchiveId: 0 });
        }
    };
    render(): JSX.Element {

        let identity = identityStorage.get();

        let isNotSuperAdmin = clientWriteUserRoles.includes(identity.userRole);

        return (
            <>
                <h3>Reporting Configs {this.state.enabled ? '' : '(archived)'}</h3>
                {
                    writeUserRoles.includes(identity.userRole) &&
                    <div className='flex-container margin-bottom-10px'>
                        <div>
                            <button type="button" className="btn cb-btn" onClick={this.onCreateNewClick}>Create New Reporting Config</button>
                            {isNotSuperAdmin &&
                                <button type="button" className="btn btn-light" onClick={this.onImportClick}>Import Reporting Config</button>
                            }
                        </div>
                    </div>
                }
                <div className='flex-container background-whitesmoke padding-left-right-5px'>
                    <div className="row no-gutters mt-4 mb-2">
                        <div className="col-auto">
                            <form onSubmit={this.onSubmit} className="display-flex align-items-center">
                                <div className="report-search-input-wrapper">
                                    <input
                                        type="text"
                                        value={this.state.name}
                                        onChange={this.onNameChange}
                                        className="form-control report-search-input"
                                        placeholder="Search By Name or Id" />
                                    <div className="report-search-input-actions">
                                        <button
                                            type="button"
                                            value="Clear"
                                            aria-label="Clear"
                                            className="custom-icon-button report-search-input-clear-button"
                                            onClick={this.onClearClick}>
                                            <ClearIcon className="report-clear-icon color-black-important" title={iconTooltip.clear} />
                                        </button>
                                        <span className="report-search-divider"></span>
                                        <button
                                            type="submit"
                                            value="Search"
                                            aria-label="Search"
                                            className="custom-icon-button report-search-input-search-button">
                                            <SearchIcon className="report-search-icon color-black-important" title={iconTooltip.search} />
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="display-flex align-items-center margin-left-10px">
                            {this.state.showDownloadSummarySpinner ? <Spinner /> :
                                <button type="button" className="custom-icon-button" onClick={this.onOpenDownloadSummaryModal}>
                                    <CustomIcon icon={DownloadIcon} title={iconTooltip.downloadReportConfigSummary} />
                                </button>
                            }
                        </div>
                        <div className="display-flex align-items-center margin-left-10px">
                            <label className="margin-0 display-flex">
                                <input
                                    type="checkbox"
                                    checked={!this.state.enabled}
                                    onChange={this.onEnabledChange} />
                                <span>Archived</span>
                            </label>
                        </div>
                    </div>
                    {identity.userRole === userRole.localAdmin && this.state.showFourEyesReleaseSwitch &&
                        <SwitchComponent
                            label='Four eyes release process'
                            disableLabel='Disabled'
                            enableLabel='Enabled'
                            labelClasses='default-label'
                            info={iconTooltip.fourEyesReleaseSwitch}
                            checked={this.state.isFourEyesReleaseEnabled}
                            onChange={this.onEnableDisableForEyesReleaseSwitch}
                        />
                    }
                </div>

                <div className="mb-4">
                    <ServerDataGrid
                        columns={getColumns(
                            this.onEditClick,
                            this.onCopyClick,
                            this.state.enabled,
                            this.onDownloadClick,
                            this.onRemoveClick,
                            this.onCopyConfigSourceClick,
                            this.state.showSpinnerForId,
                            this.state.showSpinnerForDownloadId,
                            this.onInfoClick,
                            this.onViewReleasedClick,
                            this.onChangeDataSourceClick,
                            this.onArchiveClick,
                            this.onMouseLeaveDerscription,
                            this.state.isFourEyesReleaseEnabled,
                            this.state.showSpinnerForChangeDataSourceId,
                            this.state.showSpinnerForArchiveId,
                            this.state.showSpinnerForRemoveConfigId)}
                        uniqueName={uniqueName}
                        dataSourceRoute="report/page"
                        pageSize={10}
                        getKey={x => x.id}
                        getAdditionalParams={() => this.state}
                        onRecordsFetched={this.onRecordsFetched}
                    />
                </div>

                <DownloadModal
                    onClose={() => { this.setState({ showDownloadPopup: false, showSpinnerForDownloadId: 0 }) }}
                    onDownload={this.onDownloadTypeSelected}
                    isOpen={this.state.showDownloadPopup}
                    showVersionSelection={true} />

                <DownloadReportConfigSummaryModal
                    isOpen={this.state.showDownloadSummaryModal}
                    onClose={() => this.setState({ showDownloadSummaryModal: false })}
                    onDownload={this.onDownloadSummaryConfirmed}
                />

                <CopyReportConfigModal />
                <ImportReportConfigModal
                    isValidationConfig={false}
                    skipDataSourcesValidation={false}
                    title='Import Report config'
                />
                {
                    this.state.showWarningModal &&
                    <WarningModal
                        onOkClick={this.onRemoveConfirmed}
                        onCancelClick={() => this.setState({ showWarningModal: false })}
                        title='Remove config'
                        message={this.state.message} />
                }
                {
                    this.state.showConfigInfoPopup &&
                    <ReportConfigInfoModal
                        configInfo={this.state.configInfo}
                        onClose={() => { this.setState({ showConfigInfoPopup: false }) }} />

                }
                {
                    this.state.showPopupOnDisableFourEyesRelease &&
                    <WarningModal
                        onOkClick={() => this.switchFourEyesRelease(false)}
                        onCancelClick={() => this.setState({ showPopupOnDisableFourEyesRelease: false })}
                        title={`Change data source of config ${this.state.changeDataSourceConfig.name}`}
                        message={disableFourEyesReleaseMessage} >
                        <div className='display-flex'>

                        </div>
                    </WarningModal>
                }
                {
                    this.state.showPopupChangeDataSource &&
                    <ChangeDataSourceModal
                        title={`Change datasource for ${this.state.changeDataSourceConfig.name}`}
                        onSaveClick={this.onChangeDataSourceAccepted}
                        onClose={() => this.setState({ showSpinnerForChangeDataSourceId: 0, showPopupChangeDataSource: false })}
                    />
                }
            </>
        );
    }
}

export default ReportHomePage;